<template>
  <div>
    <div class="row mb-2">
      <button v-if="userEditRight" type="button" @click="addPackage()" class="btn btn-info">
        Create Package
      </button>
    </div>
    <div class="row">
      <div class="table-responsive table-bordered" v-if="packages.length > 0">
        <table class="table col-md-12">
          <thead>
            <tr class="text-nowrap">
              <th>Description</th>
              <th>NRC (excl. VAT)</th>
              <th>MRC (excl. VAT)</th>
              <th>MRC (incl. VAT)</th>
              <th>Expired</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="rocketseedPackage in packages"
              :key="rocketseedPackage.rocketseedPackageNumber"
            >
              <td>{{ rocketseedPackage.label }}</td>
              <td>
                {{ getSetupFee(rocketseedPackage.prices, period) }}
              </td>
              <td>
                {{
                  getPrice(rocketseedPackage.prices, period)
                }}
              </td>
              <td>
                {{
                  getPrice(rocketseedPackage.prices, period, true)
                }}
                <span
                  v-if="userEditRight"
                  style="cursor: pointer"
                  v-tooltip="'Edit Row Price'"
                  @click="openPriceModal(rocketseedPackage)"
                  class="pull-right"
                >
                  <em class="fa fa-edit fa-fw text-green"></em>
                </span>
              </td>
              <td class="text-center">
                <span
                class="badge"
                :class="
                  rocketseedPackage.expired ? 'badge-warning' : 'badge-green'
                "
                >{{ rocketseedPackage.expired }}
              </span>
              </td>
              <td class="text-center">
                <button
                  v-if="userEditRight"
                  v-tooltip="'Edit Package'"
                  type="button"
                  @click="editPackage(rocketseedPackage)"
                  class="btn btn-sm btn-info m-1"
                >
                  <em class="fa fa-edit fa-fw"></em>
                </button>
                <button
                  v-if="userEditRight"
                  v-tooltip="'Delete Package'"
                  type="button"
                  @click="deletePackage(rocketseedPackage)"
                  class="btn btn-sm btn-primary"
                >
                  <em class="fa fa-trash fa-fw"></em>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert alert-info col-md-12">
        No price packages to display
      </div>
    </div>
    <AddPriceModal
      ref="addPriceModal"
      :row-price="rowPrice"
      :new-price="newPrice"
      :package-description="packageDescription"
      @addPrice="addPrice"
      @pricesAdded="getPackages()"
    />
    <modal
      :title="
        pricePackage.rocketseedPackageNumber ? 'Edit Package' : 'Add New Package'
      "
      ref="modifyPackage"
      size="modal-lg"
      @save="pricePackage.rocketseedPackageNumber ? savePackage() : createPackage()"
    >
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label">Description</label>
          <input
            type="text"
            class="form-control"
            v-model="pricePackage.label"
          />
        </div>
      </div>
      <div class="row" v-if="pricePackage.rocketseedPackageNumber">
        <div class="form-group col-md-10">
          <label class="control-label"> Expired </label>
          <v-select :options="['true', 'false']" placeholder="false" v-model="pricePackage.expired"></v-select>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import PriceFunctions from "./PriceFunctions";
import AddPriceModal from "@/components/Admin/Modals/AddPriceModal";
import Modal from "@/components/GeneralComponents/Modal";

export default {
  extends: PriceFunctions,
  components: {
    AddPriceModal,
    Modal,
  },
  props: {
    productNumber: {
      type: Number,
      required: true,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      period: this.getCurrentPeriod(),
      newPrice: {},
      pricePackage: {},
      rowPrice: [],
      packages: [],
      packageDescription: '',
    };
  },
  mounted() {
    this.getPackages();
  },
  methods: {
    getPackages() {
      this.$http.get(this.$config.aimsAPI + "pricing/packages/product/" + this.productNumber + "/RocketseedPackage")
        .then(
          (response) => {
            this.packages = response.data;
          },
          (error) => {
            this.showError("Error fetching Rocketseed Packages", error);
            console.error(error);
          }
        );
    },
    addPackage() {
      this.pricePackage = this.deepCopyObject({
        class: "za.co.adept.aims.rocketseed.RocketseedPackage",
        productNumber: this.productNumber,
      });
      this.$refs.modifyPackage.open();
    },
    editPackage(rocketseedPackage) {
      this.pricePackage = this.deepCopyObject(rocketseedPackage);
      this.$refs.modifyPackage.open();
    },
    openPriceModal(rocketseedPackage) {
      this.rowPrice = this.deepCopyObject(rocketseedPackage.prices || []);
      this.packageDescription = rocketseedPackage.label || '';
      this.newPrice = this.deepCopyObject({
        rocketseedPackageNumber: rocketseedPackage.rocketseedPackageNumber,
        class: "za.co.adept.aims.rocketseed.RocketseedPackagePrice",
        validFrom: 0,
        validUntil: 0,
        setupfee: 0
      });
      this.$refs.addPriceModal.open();
    },
    addPrice(newPrice) {
      this.rowPrice.forEach((price) => {
        if (price.validUntil == 0) {
          if (newPrice.validFrom % 100 > 1) {
            price.validUntil = newPrice.validFrom - 1;
          } else {
            price.validUntil = newPrice.validFrom - 100 + 11;
          }
        }
      });
      this.rowPrice.push(newPrice);
      this.newPrice = this.deepCopyObject({
        rocketseedPackageNumber: newPrice.rocketseedPackageNumber,
        class: newPrice.class,
        validFrom: 0,
        validUntil: 0,
      });
    },
    savePackage() {
      this.$refs.modifyPackage.isLoading();
      this.$http.put(this.$config.aimsAPI + 'pricing/rocketseedpackages/update', this.pricePackage)
        .then(
          (response) => {
            this.showSuccess("Saved Package Successfully");
            this.$refs.modifyPackage.close();
            this.getPackages();
          },
          (error) => {
            this.showError("Error saving Rocketseed Package", error);
            console.error(error);
          }
        )
        .finally(() => {
          this.$refs.modifyPackage.isLoading();
        });
    },
    createPackage() {
      this.$refs.modifyPackage.isLoading();
      this.$http.post(this.$config.aimsAPI + 'pricing/rocketseedpackages/save', this.pricePackage)
        .then(
          (response) => {
            this.showSuccess("Saved Package Successfully");
            this.$refs.modifyPackage.close();
            response.data.prices = [];
            this.openPriceModal(response.data);
          },
          (error) => {
            this.showError("Error saving Rocketseed Package", error);
            console.error(error);
          }
        )
        .finally(() => {
          this.$refs.modifyPackage.isLoading();
        });
    },
    deletePackage(rocketseedPackage) {
      this.$swal({
        title: "Are you sure you want to delete this package?",
        text: rocketseedPackage.description,
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(
              this.$config.aimsAPI + 
              'pricing/pricepackages/' + 
              rocketseedPackage.objKey +
              "?objClassName=" +
              rocketseedPackage.class
            )
            .then(
              () => {
                this.showSuccess("Successfully deleted Rocketseed Package");
                this.getPackages();
              },
              (error) => {
                this.showError("Error deleting Rocketseed Package", error);
                console.error(error);
              }
            );
        }
      });
    },
  },
};
</script>
